import { faLocationDot, faSoap, faUsersViewfinder } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as GivebutterPlusSplash from 'components/givebutter-plus-splash/GivebutterPlusSplash';
import { DATA_HYGIENE_HELP_LINK } from 'constants/links';
import DataHygieneSplash from 'images/data-hygiene-splash.webp';

const DataHygieneGivebutterPlusSplashPage = () => {
    return (
        <GivebutterPlusSplash.Root>
            <GivebutterPlusSplash.Content>
                <GivebutterPlusSplash.Header>
                    <GivebutterPlusSplash.Text>
                        <GivebutterPlusSplash.HeaderLogo />
                        <GivebutterPlusSplash.Title>Data Hygiene</GivebutterPlusSplash.Title>
                        <GivebutterPlusSplash.Description>
                            Keep your contact records clean and correct with data hygiene. We verify
                            addresses, recognize mistakes, and help you maintain spotless donor
                            information.
                        </GivebutterPlusSplash.Description>
                        <GivebutterPlusSplash.CallToAction learnMoreUrl={DATA_HYGIENE_HELP_LINK} />
                    </GivebutterPlusSplash.Text>
                    <GivebutterPlusSplash.HeaderImage>
                        <img src={DataHygieneSplash} alt="Data hygiene illustration" />
                    </GivebutterPlusSplash.HeaderImage>
                </GivebutterPlusSplash.Header>
                <GivebutterPlusSplash.FeatureCardRow>
                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-1">
                            <FontAwesomeIcon icon={faUsersViewfinder} size="xl" />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                Routine checks
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                We regularly run checks to ensure your data stays accurate and
                                up-to-date, notifying you of any potential issues.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>

                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-2">
                            <FontAwesomeIcon size="xl" icon={faLocationDot} />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                Contact verification
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Verify addresses, update bounced emails or phone numbers, and make
                                sure all contact information is ready for any type of communication.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>

                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-3">
                            <FontAwesomeIcon size="xl" icon={faSoap} />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                Easy clean up
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Effortlessly clean up missing and incorrect contact information with
                                our user-friendly layout built for quick editing and management.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>
                </GivebutterPlusSplash.FeatureCardRow>
                <GivebutterPlusSplash.Footer />
            </GivebutterPlusSplash.Content>
        </GivebutterPlusSplash.Root>
    );
};

export { DataHygieneGivebutterPlusSplashPage };
